<app-navbar-style-two></app-navbar-style-two>
<div class="page-title-area mt-0" *ngFor="let Content of pageTitle;" >
    <h1>{{Content.title}}</h1>
   
</div>

<script async src="https://www.googletagmanager.com/gtag/js?id=G-C8F6CSWD62"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-C8F6CSWD62');
</script>
